import { PostHogProvider } from 'posthog-js/react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css'

import * as Sentry from '@sentry/react'

import App from '@src/App'
import '@src/index.css'
import setupBigIntJSON from '@src/jsonBigInt'
import reportWebVitals from '@src/reportWebVitals'

Sentry.init({
    // dsn: 'https://51d13d4e6600f759933e1ea3d9d670c7@o4508241426513920.ingest.us.sentry.io/4508241436213248',
    dsn: 'https://666ef99a4bfd4b9d6ad9e85d5757747c@o4509017318096896.ingest.us.sentry.io/4509017320259584',
    integrations: [Sentry.browserTracingIntegration()],
    // Set sampling rate to reduce the number of events sent to Sentry
    tracesSampleRate: 1, // Sample 20% of transactions
    // Optional: Add different sampling rates for specific operations
    tracesSampler: () => {
        return 1
    },
    enabled: process.env.REACT_APP_ENV == 'production',
    environment: process.env.REACT_APP_ENV,
    beforeSend: event => {
        if (process.env.REACT_APP_ENV == 'production') {
            return event
        }
        return null
    },
})

/**
 * Overrides JSON.parse and JSON.stringify to handle BigInt values, which JSON does not support by default.
 */
setupBigIntJSON()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

// PostHog configuration options
const posthogOptions = {
    api_host: 'https://us.i.posthog.com',
}

// The API key to use
const posthogApiKey = process.env.REACT_APP_POSTHOG_API_KEY || ''

root.render(
    <BrowserRouter>
        <PostHogProvider apiKey={posthogApiKey} options={posthogOptions}>
            <App />
        </PostHogProvider>
    </BrowserRouter>
)

reportWebVitals()
